import { useMutation } from '@tanstack/react-query';

import { CustomerRegistration } from '@/models';
import { getSMPBackendAPIPublic, RegisterCustomerRequest } from '@/proxy-web';

const toRequest = (customer: CustomerRegistration): RegisterCustomerRequest => ({
  company: customer.company,
  supplement: customer.supplement,
  street: customer.street,
  zip: customer.zip,
  city: customer.city,
  country: customer.country,
  firstName: customer.firstName,
  lastName: customer.lastName,
  email: customer.email,
  phone: customer.phone,
});

function registerCustomer(model: CustomerRegistration): Promise<void> {
  return getSMPBackendAPIPublic().requestControllerRegisterCustomerV1(toRequest(model));
}

export function useRegisterCustomer() {
  return useMutation({ mutationFn: registerCustomer });
}
